(function ($) {
    'use strict';

    var init = function () {
        if (window.self !== window.top) {
            var observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    for (var i = 0; i < mutation.addedNodes.length; i++) {
                        var node = mutation.addedNodes[i];
                        if (node.id === 'tarteaucitronRoot') {
                            node.parentNode.removeChild(node);
                            observer.disconnect();
                            return;
                        }
                    }
                });
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }

        var iframe = document.getElementById('tec-iframe');
        if (!iframe) { return; }

        var updateIframeHeight = function () {
            try {
                var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
                if (!iframeDoc || !iframeDoc.body) return;
                var newHeight = iframeDoc.body.scrollHeight;
                iframe.style.height = newHeight + 'px';
            } catch (e) {
                console.warn('Could not update iframe height', e);
            }
        };

        var handleIframeLinks = function () {
            try {
                var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
                var links = iframeDoc.querySelectorAll('.tribe-events a');
                Array.prototype.forEach.call(links, function (link) {
                    link.addEventListener('click', function (e) {
                        e.preventDefault();
                        window.location.href = link.href;
                    });
                });
            } catch (e) {
                console.warn('Could not access iframe links', e);
            }
        };

        var installIframeMutationObserver = function () {
            try {
                var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
                var container = iframeDoc.querySelector('.tribe-events');
                if (!container) {
                    setTimeout(installIframeMutationObserver, 100);
                    return;
                }

                var mo = new MutationObserver(function () {
                    handleIframeLinks();
                    updateIframeHeight();
                });
                mo.observe(container, { childList: true, subtree: true });

                if ('ResizeObserver' in iframeDoc.defaultView) {
                    var ro = new iframeDoc.defaultView.ResizeObserver(function () {
                        updateIframeHeight();
                    });
                    ro.observe(iframeDoc.body);
                } else {
                    setInterval(updateIframeHeight, 500);
                }
            } catch (e) {
                console.warn('Could not install iframe observers', e);
            }
        };

        iframe.addEventListener('load', function () {
            updateIframeHeight();
            handleIframeLinks();
            installIframeMutationObserver();
        });

        window.addEventListener('resize', function () {
            setTimeout(updateIframeHeight, 300);
        });
    };

    $(document).ready(function () {
        init();
    });

})(jQuery);
